import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en.json";
import svTranslations from "./locales/sv.json";

const resources = {
  en: {
    translation: enTranslations,
  },
  sv: {
    translation: svTranslations,
  },
};

const syncDocumentLanguage = (language?: string) => {
  if (typeof document === "undefined" || !language) {
    return;
  }

  document.documentElement.lang = language;
  document.documentElement.dir = i18n.dir(language);
};

i18n.on("languageChanged", (language) => {
  syncDocumentLanguage(i18n.resolvedLanguage ?? language);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "sv", // Swedish as default fallback
    debug: false,

    supportedLngs: ["sv", "en"],

    detection: {
      order: ["localStorage", "navigator", "path", "htmlTag"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);
  });

export default i18n;
